import { FinancialInstitute } from "@core/models/financial-insitute.model";
import { Intermediary } from "@core/models/intermediary.model";
import { Utilities } from "@core/utils/utils";
import { TPagination } from "@custom-types/sorting";
import { ManagementState } from "@features/management/store/management.reducers";
import { AccountManager } from "@models/account-manager.model";
import { Advisor } from "@models/advisor.model";
import { Country } from "@models/country.model";
import { Document } from "@models/document.model";
import { Email } from "@models/email.model";
import { Etf } from "@models/etf-model";
import { Insurer } from "@models/insurer.model";
import { createFeatureSelector, createSelector } from "@ngrx/store";

import * as fromManagement from "./management.reducers";

export const SELECT_MANAGEMENT_STATE =
  createFeatureSelector<fromManagement.ManagementState>(
    fromManagement.MANAGEMENT_FEATURE_KEY
  );

export const SELECT_ADVISOR_LIST = createSelector(
  SELECT_MANAGEMENT_STATE,
  (state: ManagementState): Array<Advisor> => state.advisors
);

export const SELECT_INSURER_LIST = createSelector(
  SELECT_MANAGEMENT_STATE,
  (state: ManagementState): Array<Insurer> => state.insurers
);

export const SELECT_ACCOUNT_MANAGER_LIST = createSelector(
  SELECT_MANAGEMENT_STATE,
  (state: ManagementState): Array<AccountManager> => state.accountManagers
);

export const SELECT_EMAIL_LIST = createSelector(
  SELECT_MANAGEMENT_STATE,
  (state: ManagementState): Array<Email> => state.communication.emails
);

export const SELECT_DOCUMENT_LIST = createSelector(
  SELECT_MANAGEMENT_STATE,
  (state: ManagementState): Array<Document> => state.communication.documents
);

export const SELECT_EMAIL_LIST_LOADING_STATUS = createSelector(
  SELECT_MANAGEMENT_STATE,
  (state: ManagementState): boolean => state.emailsLoading
);

export const SELECT_DOCUMENT_LIST_LOADING_STATUS = createSelector(
  SELECT_MANAGEMENT_STATE,
  (state: ManagementState): boolean => state.documentsLoading
);

export const SELECT_LAST_ACTION_DATE = createSelector(
  SELECT_MANAGEMENT_STATE,
  (state: ManagementState): Date => state.lastActionDate
);

export const SELECT_MANAGEMENT_LOADING_STATUS = createSelector(
  SELECT_MANAGEMENT_STATE,
  (state: ManagementState): boolean => state.loading
);

export const SELECT_FINANCIAL_INSTITUTIONS_LIST = createSelector(
  SELECT_MANAGEMENT_STATE,
  (state: ManagementState): Array<FinancialInstitute> =>
    state.financialInstitutions
);

export const SELECT_INTERMEDIARY_LIST = createSelector(
  SELECT_MANAGEMENT_STATE,
  (state: ManagementState): Array<Intermediary> => state.intermediaries
);

export const SELECT_COUNTRY_LIST = createSelector(
  SELECT_MANAGEMENT_STATE,
  (state: ManagementState): Array<Country> => state.countries
);

export const SELECT_EMAIL = createSelector(
  SELECT_MANAGEMENT_STATE,
  (state: ManagementState): Partial<Email | null> => state.communication.email
);

export const SELECT_ETF_LIST = createSelector(
  SELECT_MANAGEMENT_STATE,
  (state: ManagementState): Array<Etf> => state.etfList
);

export const SELECT_FUND_ISIN_VALIDITY = createSelector(
  SELECT_MANAGEMENT_STATE,
  (state: ManagementState): boolean => state.valid
);

export const SELECT_EMAIL_VALIDITY = createSelector(
  SELECT_MANAGEMENT_STATE,
  (state: ManagementState): boolean => state.emailExists
);

export const SELECT_USERNAME_VALIDITY = createSelector(
  SELECT_MANAGEMENT_STATE,
  (state: ManagementState): boolean => state.usernameExists
);

export const SELECT_MANAGEMENT_PAGINATION = createSelector(
  SELECT_MANAGEMENT_STATE,
  (state: ManagementState): Partial<TPagination> | undefined => state.pagination
);

export const SELECT_DOCUMENTS_PAGINATION = createSelector(
  SELECT_MANAGEMENT_STATE,
  (state: ManagementState): Partial<TPagination> | undefined =>
    state.documentsPagination
);

export const SELECT_MANAGEMENT_LIST_LENGTH = createSelector(
  SELECT_MANAGEMENT_STATE,
  (state: ManagementState): number => state.listLength
);

export const SELECT_DOCUMENT_LIST_LENGTH = createSelector(
  SELECT_MANAGEMENT_STATE,
  (state: ManagementState): number => state.documentsLength
);

export const SELECT_MANAGEMENT_PAGE_INDEX = createSelector(
  SELECT_MANAGEMENT_STATE,
  (state: ManagementState): number =>
    Utilities.getPageIndex(state.pagination?.pageIndex)
);

export const SELECT_FINANCIAL_INSTITUTIONS_LOADING_STATUS = createSelector(
  SELECT_MANAGEMENT_STATE,
  (state: ManagementState): boolean => state.financialInstitutionsLoading
);
